import { render, staticRenderFns } from "./autoRuleComponentDialog.vue?vue&type=template&id=61036de6&"
import script from "./autoRuleComponentDialog.vue?vue&type=script&lang=js&"
export * from "./autoRuleComponentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports